import { Injectable, inject } from '@angular/core';
import {
  ApplyOrgChartImportRequest,
  StartOrgChartImportRequest,
} from '@interfaces/economic-groups/requests/apply-org-chart-import.request';
import { EconomicGroupTreeResponse } from '@interfaces/economic-groups/responses/economic-group.response';
import { OrgChartImportResponse } from '@interfaces/economic-groups/responses/org-chart-import.response';
import { VaultApiService } from '@services/api/vault-api.service';
import { Observable } from 'rxjs';

/**
 * Importação de organograma no builder do Grupo Econômico (card 3578).
 * Base `economic-groups/{groupId}/org-chart-imports`; README em `features/dashboard/economic-groups/README.md`.
 */
@Injectable({ providedIn: 'root' })
export class EconomicGroupOrgChartImportsHttpService {
  private readonly api = inject(VaultApiService);

  /** Envia o arquivo (multipart, campo `file`). Responde 202 com a importação em `Reading`. */
  start(
    groupId: string,
    payload: StartOrgChartImportRequest
  ): Observable<OrgChartImportResponse | null> {
    return this.api.post<OrgChartImportResponse>(this.baseUrl(groupId), payload, true);
  }

  /** A importação aberta mais recente do grupo (nem aplicada, nem descartada); `null` quando não há (204). */
  getLatest(groupId: string): Observable<OrgChartImportResponse | null> {
    return this.api.get<OrgChartImportResponse>(`${this.baseUrl(groupId)}/latest`);
  }

  getById(groupId: string, importId: string): Observable<OrgChartImportResponse | null> {
    return this.api.get<OrgChartImportResponse>(`${this.baseUrl(groupId)}/${importId}`);
  }

  /** Grava a proposta revisada no grupo; devolve a árvore atualizada. */
  apply(
    groupId: string,
    importId: string,
    payload: ApplyOrgChartImportRequest
  ): Observable<EconomicGroupTreeResponse | null> {
    return this.api.post<EconomicGroupTreeResponse>(
      `${this.baseUrl(groupId)}/${importId}/apply`,
      payload
    );
  }

  /** Descarta sem gravar nada no grupo (204). */
  discard(groupId: string, importId: string): Observable<void | null> {
    return this.api.delete<void>(`${this.baseUrl(groupId)}/${importId}`);
  }

  private baseUrl(groupId: string): string {
    return `economic-groups/${groupId}/org-chart-imports`;
  }
}
